module.exports = __webpack_public_path__ + "static/media/UG.dae1e194.svg";